export const otherMixin = {
  data() {
    return {
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新建",
          method: "create_m",
        },
        {
          name: "打开",
          method: "open_m",
        },
        {
          name: "过账",
          method: "Posting",
        },
        {
          name: "反过账",
          method: "UnPosting",
        },
        {
          name: "批量过账",
          method: "Postings",
        },
        {
          name: "批量反过账",
          method: "UnPostings",
        },
        {
          name: "批量删除",
          method: "Deletes",
        },
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "exportData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "input",
          label: "经办人名称 ",
          field: "handelObjectName",
          placeholder: "请输入",
        },
        {
          type: "doubleSelect",
          label: "结算对象",
          selectItem: [
            {
              field: "objectStatusConfDictId",
              placeholder: "请输入",
              setLabel: "val",
              setValue: "confDictId",
              selectChange: "GetUserDownList",
              selectOptions: [],
            },
            {
              field: "objectName",
              placeholder: "请输入",
              setLabel: "name",
              setValue: "name",
              selectOptions: [],
            },
          ],
        },
        {
          type: "doubleSelect",
          label: "费项",
          selectItem: [
            {
              field: "itemCategoryId",
              placeholder: "请输入",
              setLabel: "categoryName",
              setValue: "categoryId",
              selectChange: "GetExpenditure",
              selectOptions: [],
            },
            {
              field: "itemServiceId",
              placeholder: "请输入",
              setLabel: "title",
              setValue: "itemServiceId",
              selectOptions: [],
            },
          ],
        },
        {
          type: "deptTree",
          label: "业务网点",
          field: "businessDeptIds",
          setLabel: "departmentName",
          setValue: "deptId",
          placeholder: "请输入",
          selectOptions: [],
        },
        {
          type: "select",
          label: "过账状态",
          field: "isPosting",
          placeholder: "请选择",
          selectOptions: [
            { label: "已过账", val: 1 },
            { label: "未过账", val: 0 },
          ],
        },
        {
          type: "select",
          label: "需要核销",
          field: "isSettlement",
          placeholder: "请选择",
          selectOptions: [
            { label: "是", val: 1 },
            { label: "否", val: 0 },
          ],
        },
        {
          type: "select",
          label: "付款方式",
          field: "settlementMethodConfDictId",
          placeholder: "请选择",
          setLabel: "val",
          setValue: "confDictId",
          selectOptions: [],
        },
      ],

      queryData: {
        businessDeptId: null,
        isPosting: 0,
        isSettlement: null,
        itemCategoryId: null,
        itemServiceId: null,
        objectName: null,
        objectStatusConfDictId: null,
        settlementMethodConfDictId: null,
        startCreateTime: null,
        endCreateTime: null,
        startOccurrenceTime: null,
        endOccurrenceTime: null,
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "1",
          label: "发生时间",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
    };
  },
  methods: {
    rowCallback(data, name) {
      this[name](data);
    },
    // 获取结算对象类型 & 付款方式
    getConfDictValDownList(PARAM) {
      this.$API.wtl_getConfDictValDownList({ dictType: PARAM }).then((res) => {
        if (res.data.status === "success") {
          if (PARAM === "object_status") {
            this.baseConfig[1].selectItem[0].selectOptions =
              res.data.result || [];
          }
          if (PARAM === "settlement_method") {
            this.baseConfig[6].selectOptions = res.data.result || [];
          }
        } else {
          console.log(res.data.message);
        }
      });
    },
    // 根据结算对象类型获取结算对象
    GetUserDownList(e) {
      let arr = this.baseConfig[1].selectItem[0].selectOptions;
      let num = arr.findIndex((element) => element.confDictId == e);
      let objectKey = arr[num].key;
      this.$API
        .wtl_getObjectUserDownList({
          key: objectKey,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          if (res.data.status === "success") {
            let result = res.data.result.data || [];
            this.queryData.objectName = "";
            this.baseConfig[1].selectItem[1].selectOptions = result;
          }
        });
    },
    // 获取费项类型下拉列表
    GetItemCategorChoose() {
      this.$API.itemCategorChoose().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result || [];

          this.baseConfig[2].selectItem[0].selectOptions = result;
        }
      });
    },

    // 根据类别和费项类型获取费项
    GetExpenditure(e) {
      this.$API.CategoryServiceList({ categoryId: e }).then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result || [];
          this.queryData.serviceId = "";
          this.baseConfig[2].selectItem[1].selectOptions = result;
        }
      });
    },

    // 获取业务部门（组织架构列表）
    GetDept() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result.data || [];
          this.baseConfig[3].selectOptions = result;
        }
      });
    },

    // 时间查询框选择时间时的事件
    queryBtn_time(t1, t2) {
      this.startTime_a = t1;
      this.endTime_a = t2;
      if (t1 && t2) {
        this.GetData();
      }
    },
    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.startTime_a = "";
      this.endTime_a = "";
      this.queryData.itemCategoryId = "";
      this.queryData.itemServiceId = "";
      this.queryData.objectName = "";
      this.queryData.objectStatusConfDictId = "";
      this.GetData();
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 查询框对象字段级联事件
    ObjectChange(e) {
      console.log(e);
    },

    // 时间查询框选择时间时的事件
    queryBtn_time(t1, t2) {
      this.startTime_a = t1;
      this.endTime_a = t2;
      if (t1 && t2) {
        this.GetData();
      }
    },
  },
  created() {
    let permissValArr = [];
    if (this.tableType === "OtherIncome") {
      permissValArr = [
        "admin:other_finance:addOtherIn",
        "admin:other_finance:getOtherInDetail",
        "admin:other_finance:updateOtherIn",
        "admin:other_finance:unPostingOtherIn",
      ];
    }
    if (this.tableType === "OtherExpenses") {
      permissValArr = [
        "admin:other_finance:addOtherOut",
        "admin:other_finance:getOtherOutDetail",
        "admin:other_finance:updateOtherOut",
        "admin:other_finance:unPostingOtherOut",
      ];
    }
    for (let i in permissValArr) {
      this.BTN_CONFIG[i].permissVal = permissValArr[i];
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.getConfDictValDownList("object_status");
    this.getConfDictValDownList("settlement_method");
    this.GetItemCategorChoose();
    this.GetDept();
    this.GetData();
  },
};
